import { getContentOperatingHours } from './helpers/getContentOperatingHours';

export function useContentOperatingHours(
  ...args: Parameters<typeof getContentOperatingHours>
) {
  return getContentOperatingHours(...args);
}
